import { useEffect, useState } from 'react'

const ButtonSwitch = ({
    onChange,
    offValue,
    onValue,
    isActive = false,
    disabled = false,
    readOnly = false
}) => {
    const [active, setActive] = useState(isActive)

    const handleClick = (e) => {
        e.preventDefault()
        setActive(!active)
        onChange(e)
    }

    useEffect(() => {
        setActive(isActive)
    }, [isActive])

    return (
        <div className={`button-toggle-wrap ${active ? 'button-toggle-wrap--active' : ''}`}>
            <span className="button-toggle-label button-toggle-label--off">{offValue ?? 'Off'}</span>
            <button
                type="button"
                className={`button-toggle ${active ? 'active' : ''}`}
                onClick={handleClick}
                disabled={disabled || readOnly}
            >
                <div className="handle"></div>
            </button>
            <span className="button-toggle-label button-toggle-label--on">{onValue ?? 'On'}</span>
        </div>
    )
}

export default ButtonSwitch